import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import Modal from "@mui/material/Modal";
import { OrderContext } from "../contexts/OrderContext";
import autoTable from "jspdf-autotable";
import { PDFDocument } from "pdf-lib";
import {
  Box,
  Grid,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  Autocomplete,
  Checkbox,
  Select,
  Divider,
  FormControl,
  InputLabel,
  IconButton,
} from "@mui/material";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import QRCode from "qrcode";
import loadImage from "blueimp-load-image";

import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import editicon from "../assets/img/icons/edit.png";
import downloadicn from "../assets/img/icons/dwnld.png";
import previewicon from "../assets/img/icons/img.png";
import deleteicon from "../assets/img/icons/delete.png";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

const OrderSearch = () => {
  const { storeData, fetchOrders } = useContext(OrderContext); // Fetch data from context
  const [filters, setFilters] = useState({
    from_orderdate: "",
    to_orderdate: "",
    from_deliverydate: "",
    to_deliverydate: "",
    customer_ref_no: "",
    karigar_id: "",
    work_status: "",
    description_keyword: "",
  });

  const [orders, setOrders] = useState([]);
  // const originalOrdersRef = useRef(initialOrders);
  const token = localStorage.getItem("authToken");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isRemoveMediaOpen, setIsRemoveMediaOpen] = useState(false);
  const [isAddMediaOpen, setIsAddMediaOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage, setOrdersPerPage] = useState(10); // Number of orders per page
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const role = localStorage.getItem("userRole");
  const [orderNumber, setOrderNumber] = useState("");
  const [updateWorkStatus, setUpdateWorkStatus] = useState("");

  const [userDetails, setUserDetails] = useState(null);
  useEffect(() => {
    const selectedMfr = JSON.parse(localStorage.getItem("selectedMfr"));

    if (selectedMfr) {
      setUserDetails(selectedMfr);
    }
  }, []);

  const handleSelect = (storeOrderNo) => {
    setSelectedOrders((prevSelected) =>
      prevSelected.includes(storeOrderNo)
        ? prevSelected.filter((no) => no !== storeOrderNo)
        : [...prevSelected, storeOrderNo]
    );
  };

  const handleDeliveryToWorkshop = async () => {
    if (selectedOrders.length === 0) {
      setSnackbarMessage("Please select at least one order.");
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/updateStatusBulk`,
        { storeorderno: selectedOrders },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (response.status === 200) {
        setSnackbarMessage("Orders successfully updated!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setSelectedOrders([]); // Clear selection
        fetchOrders();
        fetchsearchOrders(); // Refresh order list after update
      }
    } catch (error) {
      console.error("Error updating orders:", error);
      setSnackbarMessage(
        error.response?.data?.data?.message ||
        "Failed to update orders. Please try again."
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        // Set the Base64 image preview and the actual image file
        setEditedOrder((prevState) => ({
          ...prevState,
          order_images: reader.result, // Store the Base64 string for preview
          imageFile: file, // Store the actual image file for submission
        }));
      };

      reader.readAsDataURL(file); // Convert the file to Base64 string for preview
    }
  };

  // Extract dropdown options from context
  // const { karigars = [], allstatus = [], customers = [] } = storeData;

  const {
    designs = [],
    finishtypes = [],
    itemtypes = [],
    metaltypes = [],
    purities = [],
    screwTypes = [],
    allstatus = [],
    stores = [],
    karigars = [],
    customers = [],
    MFR = [],
    latestOrder,
    mfrstore = [],
  } = storeData;

  // console.log('==============mfrstore======================');
  // console.log(mfrstore);
  // console.log('====================================');

  // console.log('==============customers======================');
  // console.log(customers);
  // console.log('====================================');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const fetchsearchOrders = async (page = 1) => {
    try {
      let mfr_id = ""; // Retrieve mfr_id from localStorage
      if (role === "MFR") {
        mfr_id = localStorage.getItem("id");
      } else {
        const selectedManufacturer = JSON.parse(
          localStorage.getItem("selectedMfr")
        );
        mfr_id = selectedManufacturer?.id;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/orderlist`,
        {
          params: { ...filters, page, limit: 25, mfr_id },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      setOrders(response.data.data.orders);

      const calculatedTotalPages = Math.ceil(
        response.data.data.orders.length / ordersPerPage
      );
      setTotalPages(calculatedTotalPages);

      // console.log("Calculated total pages:", calculatedTotalPages); // Check totalPages
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const fetchOrderByStoreOrderNo = async (orderNumber) => {
    try {
      let mfr_id = ""; // Retrieve mfr_id based on user role
      if (role === "MFR") {
        mfr_id = localStorage.getItem("id");
      } else {
        const selectedManufacturer = JSON.parse(
          localStorage.getItem("selectedMfr")
        );
        mfr_id = selectedManufacturer?.id || "";
      }

      // Ensure mfr_id and storeorderno exist before making the request
      if (!mfr_id || !orderNumber) {
        console.error("Manufacturer ID and Store Order Number are required.");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/fetchorder/orderdetail`,
        {
          params: {
            mfr_id,
            storeorderno: orderNumber, // Pass as query params
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      setOrders(response.data.data.orders); // Set the orders in state
    } catch (error) {
      console.error("Error fetching order:", error);
    }
  };


   const isKarigarOverdue = (order) => {
    const excludedStatuses = [5, 6, 7, 9, 11];
    const today = new Date();
    const karigarDate = new Date(order.karigar_delivery_date); // your field name

    if (excludedStatuses.includes(order.work_status_id)) return false;
    return karigarDate < today;
  };

  // 🔴 filter and SET orders state directly
  const filterKarigarOverdue = () => {
    const filtered = orders.filter(isKarigarOverdue);
    setOrders(filtered);
  };


  const resetKarigarFilter = () => {
   fetchsearchOrders(1);
};


  const handleSearch = () => {
    setSearchTerm("");
    setOrderNumber("");
    fetchsearchOrders(1);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    setSelectedOrder([]);
  };

  const filteredOrders = orders.filter((row) =>
    Object.values(row).some(
      (value) =>
        value !== null &&
        value !== undefined &&
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;

  // Get the orders to display on the current page
  let currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  useEffect(() => {
    fetchsearchOrders();
  }, [ordersPerPage]);

  const [isModalOpen, setIsModalOpen] = useState(false); // Ensure state is declared
  const [editedOrder, setEditedOrder] = useState(null); // Modal-related state

  const handleEditOrder = (order) => {
    setEditedOrder(order);
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false); // Close the modal
    setEditedOrder(null); // Clear the edited order
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditedOrder((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveEditedOrder = async () => {
    try {
      const formData = new FormData();

      // Loop through the editedOrder object and append each field to formData
      for (let key in editedOrder) {
        if (editedOrder.hasOwnProperty(key)) {
          // Handle the image file separately
          if (key === "imageFile" && editedOrder[key]) {
            // Append the image as the file
            formData.append("image", editedOrder[key]);
          } else {
            const value = editedOrder[key];

            // Check for empty or null values and handle accordingly
            if (value === null || value === undefined || value === "") {
              continue; // Skip appending null or empty values
            }

            // Check if the value should be an integer
            if (key === "orderid" || key === "someIntegerField") {
              // Adjust field name as per your needs
              formData.append(key, parseInt(value)); // Convert to integer before appending
            }
            // Check if the value should be a decimal
            else if (key === "price" || key === "someDecimalField") {
              // Adjust field name as per your needs
              formData.append(key, parseFloat(value)); // Convert to decimal before appending
            }
            // For other fields, append as string
            else {
              formData.append(key, value.toString()); // Ensure value is a string
            }
          }
        }
      }

      // Send the formData in the API request
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/updateorder`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Add token for authorization
          },
        }
      );

      setSnackbarMessage("Order updated successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
      fetchsearchOrders();
      fetchOrders();
      handleModalClose();
      // setTimeout(() => {
      //   handleModalClose();  // Close the modal after the timeout
      // }, 3000);
    } catch (error) {
      setSnackbarMessage("Failed to update the order.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      console.error("Error saving edited order:", error);
    }
  };

  const handleDownloadPdf = async (order) => {
    const capitalizeFirst = (text) =>
      !text || typeof text !== "string"
        ? text
        : text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

    const formatDateToDDMMYYYY = (dateStr) => {
      if (!dateStr) return "N/A";
      const date = new Date(dateStr);
      if (isNaN(date)) return "Invalid Date";
      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${date.getFullYear()}`;
    };

    const convertToCompressedBase64 = async (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const maxDim = 1000;
          let { width, height } = img;

          if (width > maxDim || height > maxDim) {
            const scale = Math.min(maxDim / width, maxDim / height);
            width = width * scale;
            height = height * scale;
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          const dataUrl = canvas.toDataURL("image/jpeg", 0.7);
          resolve(dataUrl);
        };
        img.onerror = reject;
        img.src = url;
      });
    };

    const isImageUrl = (url) =>
      ["jpg", "jpeg", "png", "gif", "webp"].some((ext) =>
        url.toLowerCase().includes(`.${ext}`)
      );
    const isPdfUrl = (url) => /\.pdf$/i.test(url);

    const fetchPdfBytes = async (url) => {
      const response = await fetch(url);
      return new Uint8Array(await response.arrayBuffer());
    };

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const headerHeight = 25;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.text(order.store_name || "Store", pageWidth / 2, 12, {
      align: "center",
    });

    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    doc.text("( JOBCARD ISSUE )", pageWidth / 2, 20, { align: "center" });

    doc.setDrawColor(0);
    doc.setLineWidth(0.3);
    doc.line(0, headerHeight + 1, pageWidth, headerHeight + 1);

    let qrDataUrl = "";
    try {
      qrDataUrl = await QRCode.toDataURL(order.storeorderno || "", {
        errorCorrectionLevel: "H",
        margin: 1,
        width: 60,
      });
    } catch (err) {
      console.warn("QR generation failed", err);
    }

    let metaY = headerHeight + 10;
    const addLabelValue = (label, value) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text(`${label}:`, 8, metaY);
      const labelWidth = doc.getTextWidth(`${label}:`);
      doc.setFont("helvetica", "normal");
      doc.text(`${value}`, 8 + labelWidth + 2, metaY);
      metaY += 6;
    };

    addLabelValue("Order No", order.storeorderno);
    addLabelValue("Order Date", formatDateToDDMMYYYY(order.orderdate));
    addLabelValue("Karigar", order.karigar_name);

    if (qrDataUrl) {
      const qrSize = 25;
      doc.addImage(
        qrDataUrl,
        "PNG",
        pageWidth - qrSize - 10,
        headerHeight + 4,
        qrSize,
        qrSize
      );
    }

    const tableY = Math.max(metaY, headerHeight + 34);
    const tableBody = [
      [
        "Item",
        capitalizeFirst(order.itemtype_name),
        "Purity",
        order.purity,
        "",
        "",
      ],
      [
        "Design",
        capitalizeFirst(order.design_name),
        "PCS",
        order.pcs,
        "Size",
        order.size_len,
      ],
      ["Gross Wt", order.weight, "Net Wt", order.netwt, "", ""],
      ["Description", { content: order.description || "", colSpan: 5 }],
    ];
    doc.autoTable({
      startY: tableY,
      body: tableBody,
      theme: "grid",
      styles: { fontSize: 10, textColor: [40, 40, 40] },
      columnStyles: {
        0: { cellWidth: 27 },
        1: { cellWidth: 38 },
        2: { cellWidth: 27 },
        3: { cellWidth: 38 },
        4: { cellWidth: 27 },
        5: { cellWidth: 38 },
      },
      margin: { left: 5, right: 5 },
    });

    let contentY = doc.lastAutoTable.finalY + 10;

    doc.setFont("helvetica", "bold");
    doc.setTextColor(255, 0, 0);
    doc.text(
      `Expected Date: ${formatDateToDDMMYYYY(order.karigar_delivery_date)}`,
      pageWidth / 2,
      contentY,
      { align: "center" }
    );
    doc.setTextColor(0, 0, 0);
    contentY += 10;

    let images = [];
    try {
      images = JSON.parse(order.order_images || "[]");
    } catch { }

    let firstImage = true;

    for (const file of images) {
      if (isImageUrl(file)) {
        try {
          const base64 = await convertToCompressedBase64(file);
          const { width, height } = doc.getImageProperties(base64);

          const isPortrait = height >= width;
          let imgW, imgH;

          if (firstImage) {
            if (isPortrait) {
              imgH = 140;
              imgW = (imgH / height) * width;
            } else {
              imgW = 180;
              imgH = (imgW / width) * height;
            }
            doc.addImage(
              base64,
              "JPEG",
              (pageWidth - imgW) / 2,
              contentY,
              imgW,
              imgH
            );
            contentY += imgH + 10;
            firstImage = false;
          } else {
            doc.addPage();
            if (isPortrait) {
              imgH = 180;
              imgW = (imgH / height) * width;
            } else {
              imgW = 180;
              imgH = (imgW / width) * height;
            }
            doc.addImage(
              base64,
              "JPEG",
              (pageWidth - imgW) / 2,
              (pageHeight - imgH) / 2,
              imgW,
              imgH
            );
          }
        } catch (err) {
          console.warn("Failed to load image:", file, err);
        }
      }
    }

    const basePdfBytes = doc.output("arraybuffer");
    const mainPdf = await PDFDocument.load(basePdfBytes);

    for (const file of images) {
      if (isPdfUrl(file)) {
        try {
          const pdfBytes = await fetchPdfBytes(file);
          const externalPdf = await PDFDocument.load(pdfBytes);
          const copiedPages = await mainPdf.copyPages(
            externalPdf,
            externalPdf.getPageIndices()
          );
          copiedPages.forEach((page) => mainPdf.addPage(page));
        } catch (err) {
          console.warn("Failed to load PDF:", file, err);
        }
      }
    }

    const finalBytes = await mainPdf.save();
    const blob = new Blob([finalBytes], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `order_${order.storeorderno || "download"}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(link.href);
  };

  const handleOpenRemoveMedia = (order) => {
    setSelectedOrder(order);
    setIsRemoveMediaOpen(true);
  };

  const handleOpenAddMedia = (order) => {
    setSelectedOrder(order);
    setIsAddMediaOpen(true);
  };

  const handleCloseModals = () => {
    setIsRemoveMediaOpen(false);
    setIsAddMediaOpen(false);
    setSelectedOrder(null);
    setSelectedFiles([]);
  };

  const handleUploadMedia = async () => {
    try {
      if (!selectedOrder || selectedFiles.length === 0) {
        console.error("No order selected or no files chosen.");
        return;
      }

      const formData = new FormData();
      selectedFiles.forEach((file) => formData.append("file", file));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/${selectedOrder.orderid}/media/upload`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        // console.log("Media uploaded successfully:", data);
        setSelectedOrder((prev) => ({
          ...prev,
          order_images: data.updatedOrder.order_images,
        }));
        setSnackbarMessage("Media uploaded successfully!");
        setSnackbarSeverity("success");
        // setSnackbarOpen(true);
        setOpenSnackbar(true);
        await handleSearch();
        // Close the modal
        handleCloseModals();
      } else {
        console.error("Failed to upload media:", data);
      }
    } catch (error) {
      console.error("Error uploading media:", error);
    }
  };

  // Handle media removal
  const handleRemoveMedia = async (mediaUrl) => {
    if (!selectedOrder) return;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/${selectedOrder.orderid}/media/remove`,
        { orderid: selectedOrder.orderid, mediaUrl },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (response) {
        setSnackbarMessage("Media deleted successfully!");
        setSnackbarSeverity("success");
        // setSnackbarOpen(true);
        setOpenSnackbar(true);
        await handleSearch();
      }

      handleCloseModals();
    } catch (error) {
      console.error("Failed to remove media:", error);
    }
  };

  const handleDownloadCSV = () => {
    if (orders.length === 0) {
      setSnackbarMessage("No data available to export.");
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      return;
    }

    // Define CSV headers
    const headers = [
      "ORDER ID",
      "ORDER DATE",
      "ORDER DELIVERY DATE",
      "KARIGAR DELIVERY DATE",
      "STORE NAME",
      "CUSTOMER ORDER NUMBER",
      "CUSTOMER NAME",
      "KARIGAR",
      "ITEM TYPE",
      "DESIGN",
      "GROSS WT",
      "NET WT",
      "PCS",
      "DESCRIPTION",
      "SIZE/LENGTH",
      "SCREW TYPE",
      "COLOUR",
      "WORK STATUS",
      "SEMI FINISHED WEIGHT",
      "WEIGHT RANGE",
      "COMPLETED DATE",
      "DELIVERED DATE",
    ];

    // Convert order data to CSV format
    const csvRows = [headers.join(",")]; // Add headers as first row

    orders.forEach((order) => {
      const row = [
        order.storeorderno,
        order.orderdate,
        order.karigar_delivery_date,
        order.store_name,
        order.customer_order_number,
        order.customer_name,
        order.karigar_name,
        order.itemtype_name,
        order.design_name,
        order.weight,
        order.netwt,
        order.pcs,
        order.description,
        order.size_len,
        order.screw_type_name,
        order.finishtype_name,
        order.work_status,
        order.semifinishedwt,
        order.wt_range,
      ].map((value) => `"${value}"`); // Enclose values in quotes to handle commas

      csvRows.push(row.join(",")); // Add row to CSV
    });

    // Create a Blob from the CSV data
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a temporary link element and trigger download
    const a = document.createElement("a");
    a.href = url;
    a.download = `orders_${new Date().toISOString().split("T")[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleUpdateWorkStatus = async () => {
    try {
      // http://192.168.0.107:3000/
      const response = await axios.post(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/orders/updateStatusBulk`,
        {
          storeorderno: selectedOrders,
          work_status_id: updateWorkStatus.work_status,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (response.status === 200) {
        setSnackbarMessage("Orders successfully updated!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setSelectedOrders([]); // Clear selection
        fetchOrders();
        fetchsearchOrders(); // Refresh order list after update
      }
    } catch (error) {
      console.error("Error updating orders:", error);
      setSnackbarMessage(
        error.response?.data?.data?.message ||
        "Failed to update orders. Please try again."
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  return (
    <Box p={4}>
      {/* Search orders panel */}
      <Paper
        elevation={2}
        sx={{ padding: 3, borderRadius: 2, backgroundColor: "#F7F8F9", mb: 2 }}
      >
        <Grid container spacing={3}>
          {/* First Row */}
          {/* Order Dates */}
          <Grid item xs={12} md={4}>
            <Grid container spacing={2}>
              {/* From */}
              <Grid item xs={6}>
                <TextField
                  label="Order Date From"
                  type="date"
                  name="from_orderdate"
                  value={filters.from_orderdate}
                  onChange={handleChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </Grid>
              {/* To */}
              <Grid item xs={6}>
                <TextField
                  label="Order Date To"
                  type="date"
                  name="to_orderdate"
                  value={filters.to_orderdate}
                  onChange={handleChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Order information */}
          <Grid item xs={12} md={4}>
            <Grid container spacing={2}>
              {/* Search in Descriprion */}
              <Grid item xs={6}>
                <TextField
                  label="Search in Description"
                  type="text"
                  name="description_keyword"
                  value={filters.description_keyword}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      description_keyword: e.target.value,
                    }))
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  variant="outlined"
                />
              </Grid>

              {/* Work Status */}
              <Grid item xs={6}>
                <Autocomplete
                  disablePortal
                  id="work-status-select"
                  value={
                    allstatus.find(
                      (status) => status.id === filters.work_status
                    ) || null
                  }
                  onChange={(e, newValue) =>
                    setFilters((prev) => ({
                      ...prev,
                      work_status: newValue ? newValue.id : "",
                    }))
                  }
                  options={allstatus}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search by Work Status"
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputLabelProps={{ shrink: true }} // 👈 forces label to stay above
                    />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Other Details */}
          <Grid item xs={12} md={4}>
            <Grid container spacing={2}>
              {/* Search in Orders */}
              <Grid item xs={6}>
                <TextField
                  label="Search in Orders"
                  type="text"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  variant="outlined"
                />
              </Grid>

              {/* Search Order by Order Number */}
              <Grid item xs={6}>
                <TextField
                  label="Search by Order Number"
                  type="text"
                  value={orderNumber}
                  onChange={(e) => {
                    setOrderNumber(e.target.value);
                    setCurrentPage(1);
                    fetchOrderByStoreOrderNo(e.target.value);
                  }}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Second Row */}
          {/* Delivery Dates */}
          <Grid item xs={12} md={4}>
            <Grid container spacing={2}>
              {/* Delivery Date From */}
              <Grid item xs={6}>
                <TextField
                  label="Delivery Date From"
                  type="date"
                  name="from_deliverydate"
                  value={filters.from_deliverydate}
                  onChange={handleChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </Grid>
              {/* Delivery Date To */}
              <Grid item xs={6}>
                <TextField
                  label="Delivery Date To"
                  type="date"
                  name="to_deliverydate"
                  value={filters.to_deliverydate}
                  onChange={handleChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>

          {/* store & Karigar Info */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              {/* Store Name */}
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  disablePortal
                  id="store-select"
                  value={
                    (role === "SUPERADMIN"
                      ? customers.find(
                        (customer) => customer.id === filters.customer_ref_no
                      )
                      : mfrstore.find(
                        (store) => store.id === filters.customer_ref_no
                      )) || null
                  }
                  onChange={(event, newValue) =>
                    setFilters((prev) => ({
                      ...prev,
                      customer_ref_no: newValue ? newValue.id : "",
                    }))
                  }
                  options={role === "SUPERADMIN" ? customers : mfrstore}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Store Name"
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>

              {/* Select Karigar */}
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  disablePortal
                  id="karigar-select"
                  value={
                    karigars.find(
                      (karigar) => karigar.id === filters.karigar_id
                    ) || null
                  }
                  onChange={(event, newValue) =>
                    setFilters((prev) => ({
                      ...prev,
                      karigar_id: newValue ? newValue.id : "",
                    }))
                  }
                  options={karigars}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Karigar"
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Pagination Count Dropdown, Work Status Selection Dropdown and Buttons */}
          <Grid
            container
            spacing={2}
            alignItems="center"
            marginTop={1}
            marginLeft={1}
            wrap="wrap"
          >
            {/* Left Side */}
            <Grid
              item
              xs={12}
              sm
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
              }}
            >
              {/* Page Count */}
              <FormControl
                size="small"
                variant="outlined"
                fullWidth={true}
                sx={{ maxWidth: { sm: 130 } }}
              >
                <InputLabel id="page-count-label" shrink>
                  Select Page Count
                </InputLabel>
                <Select
                  labelId="page-count-label"
                  value={ordersPerPage}
                  onChange={(e) => setOrdersPerPage(e.target.value)}
                  label="Select Page Count"
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>

              {/* Work Status */}
              <Autocomplete
                disablePortal
                id="work-status-select"
                value={
                  allstatus.find(
                    (status) => status.id === updateWorkStatus.work_status
                  ) || null
                }
                onChange={(e, newValue) => {
                  setUpdateWorkStatus((prev) => ({
                    ...prev,
                    work_status: newValue ? newValue.id : "",
                  }));
                }}
                options={allstatus}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                sx={{ width: { xs: "100%", sm: 180 } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Work Status"
                    variant="outlined"
                    size="small"
                  />
                )}
              />

              {/* Update Button */}
              <Button
                variant="contained"
                onClick={handleUpdateWorkStatus}
                size="small"
                disabled={!updateWorkStatus.work_status}
                fullWidth={true}
                sx={{
                  backgroundColor: "#0D7377",
                  color: "#fff",
                  height: 40,
                  maxWidth: { sm: "fit-content" },
                }}
              >
                Update Status
              </Button>

               <Button
                variant="contained"
                onClick={filterKarigarOverdue}
                size="small"
                fullWidth={true}
                sx={{
                  backgroundColor: "#0D7377",
                  color: "#fff",
                  height: 40,
                  maxWidth: { sm: "fit-content" },
                }}
              >
                Karigar Delivery Date Overdue
              </Button>

               <Button
                variant="contained"
                onClick={resetKarigarFilter}
                size="small"
                fullWidth={true}
                sx={{
                  backgroundColor: "#0D7377",
                  color: "#fff",
                  height: 40,
                  maxWidth: { sm: "fit-content" },
                }}
              >
                Reset
              </Button>

            </Grid>

            {/* Right Side: Search and Export Buttons */}
            <Grid
              item
              xs={12}
              sm="auto"
              sx={{
                width: "100%", // ensures full-width container
              }}
            >
              <Grid
                container
                spacing={2}
                sx={{
                  flexDirection: "row", // forces horizontal layout
                }}
              >
                <Grid item xs={6} sm="auto">
                  <Button
                    variant="contained"
                    onClick={handleSearch}
                    size="small"
                    fullWidth
                    sx={{
                      backgroundColor: "#0D7377",
                      height: 40,
                      maxWidth: { sm: "fit-content" },
                    }}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={6} sm="auto">
                  <Button
                    variant="contained"
                    onClick={handleDownloadCSV}
                    startIcon={<DownloadIcon />}
                    size="small"
                    fullWidth
                    sx={{
                      backgroundColor: "#0D7377",
                      height: 40,
                      maxWidth: { sm: "fit-content" },
                    }}
                  >
                    Export CSV
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {/* Order Details Table */}
      <TableContainer component={Paper}>
        <Table>
          {/* Table Head */}
          <TableHead sx={{ backgroundColor: "#0D7377" }}>
            <TableRow>
              {/* Select All Orders Checkbox */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Typography variant="body2" mr={0.5}>
                    Select&nbsp;All
                  </Typography>

                  <Checkbox
                    sx={{ p: 0 }}
                    icon={<CheckBoxOutlineBlank />}
                    checkedIcon={<CheckBox color="primary" />}
                    checked={
                      currentOrders.length > 0 &&
                      currentOrders.every((order) =>
                        selectedOrders.includes(order.storeorderno)
                      )
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onChange={() => {
                      const allSelected =
                        currentOrders.length > 0 &&
                        selectedOrders.length === currentOrders.length;

                      setSelectedOrders(
                        allSelected
                          ? []
                          : currentOrders.map((o) => o.storeorderno)
                      );
                    }}
                  />
                </Box>
              </TableCell>

              {/* Action Dropdown */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Actions
              </TableCell>

              {/* Order Information */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Order Info
              </TableCell>

              {/* Order Date */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Order Date
              </TableCell>

              {/* Order Type */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Order Type
              </TableCell>

              {/* Delivery Date */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Delivery Date
              </TableCell>

              {/* Store Name */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Store Name
              </TableCell>

              {/* Customer Name */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Customer Name
              </TableCell>

              {/* Karigar */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Karigar
              </TableCell>

              {/* karigar Delivery Date */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                karigar Delivery Date
              </TableCell>

              {/* Order Description */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Description
              </TableCell>

              {/* Status */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Status
              </TableCell>

              {/* Quantity */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                PCS
              </TableCell>

              {/* Purity */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Purity
              </TableCell>

              {/* Gross Weight */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Gross Wt
              </TableCell>

              {/* Net Weight */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Net wt
              </TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody sx={{ backgroundColor: "#E9F4F4" }}>
            {currentOrders.map((order) => (
              //  console.log('Rendering Order:', order),
              <TableRow key={order.orderid}>
                {/* Select Checkbox */}
                <TableCell>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelect(order.storeorderno);
                    }}
                    sx={{ p: 0 }}
                  >
                    {selectedOrders.includes(order.storeorderno) ? (
                      <CheckBox color="primary" />
                    ) : (
                      <CheckBoxOutlineBlank />
                    )}
                  </IconButton>
                </TableCell>

                {/* Action Buttons */}
                <TableCell>
                  <FormControl size="small" variant="outlined" fullWidth>
                    <Select
                      displayEmpty
                      value=""
                      renderValue={(selected) => (
                        <em style={{ color: "#888" }}>Actions</em>
                      )}
                    >
                      <MenuItem
                        onClick={() => handleEditOrder(order)}
                        value="edit"
                      >
                        <img
                          src={editicon}
                          alt="Edit"
                          style={{ width: 24, height: 24, marginRight: 5 }}
                        />
                        Edit
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleDownloadPdf(order)}
                        value="print"
                      >
                        <img
                          src={downloadicn}
                          alt="Print"
                          style={{ width: 24, height: 24, marginRight: 5 }}
                        />
                        Print
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleOpenRemoveMedia(order)}
                        value="remove"
                      >
                        <img
                          src={deleteicon}
                          alt="Remove"
                          style={{ width: 24, height: 24, marginRight: 5 }}
                        />
                        Remove Media
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleOpenAddMedia(order)}
                        value="add"
                      >
                        <img
                          src={previewicon}
                          alt="Add"
                          style={{ width: 24, height: 24, marginRight: 5 }}
                        />
                        Add Media
                      </MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>

                {/* <TableCell>{order.storeorderno}</TableCell>
                <TableCell>{order.customer_order_number}</TableCell> */}
                {/* <TableCell>
                  {order.order_images && (() => {

                    let mediaFiles;
                    try {
                      mediaFiles = typeof order.order_images === "string"
                        ? JSON.parse(order.order_images) // Parse only if it's a string
                        : order.order_images; // Use directly if it's already an array
                    } catch (error) {
                      console.error("Error parsing JSON:", order.order_images, error);
                      mediaFiles = []; 
                    }

                   

                    if (mediaFiles.length > 0) {
                      const firstMedia = mediaFiles[0]; 

                      return (
                        <a href={firstMedia} target="_blank" rel="noopener noreferrer">
                          {firstMedia.match(/\.(jpeg|jpg|png|gif|webp)$/) ? (
                            <img
                              src={firstMedia}
                              alt="Order Image"
                              style={{ width: '100px', height: '100px', objectFit: 'cover', cursor: 'pointer' }}
                            />
                          ) : firstMedia.match(/\.(mp4|webm|ogg)$/) ? (
                            <video
                              controls
                              style={{ width: '100px', height: '100px', objectFit: 'cover', cursor: 'pointer' }}
                            >
                              <source src={firstMedia} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          ) : null}
                        </a>
                      );
                    }

                    return null;
                  })()}


                </TableCell> */}

                {/* Order Information */}
                <TableCell>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    {/* Order Info Stack (TEXT LEFT) */}
                    <Box flex={1} pr={2}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-start"
                      >
                        <div
                          style={{
                            fontSize: "15px",
                            fontWeight: "bold",
                            color: "#0A4A4D",
                          }}
                        >
                          {order.storeorderno}
                        </div>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "bold",
                            color: "#4B5768",
                          }}
                        >
                          {order.itemtype_name}
                        </div>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "bold",
                            color: "#4B5768",
                          }}
                        >
                          {order.pcs} pieces
                        </div>
                        {/* <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#4B5768' }}>
                          {role === "MFR"
                            ? customers.find((customer) => customer.id === Number(order.store_id))?.name || ""
                            : customers.find((store) => store.id === Number(order.store_id))?.name || ""}
                        </div> */}
                      </Box>
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "bold",
                          color: "#4B5768",
                        }}
                      >
                        {order.deliverydate
                          ? new Date(order.deliverydate).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "2-digit",
                              }
                            )
                          : "Delivery date not set"}
                      </div>

                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "bold",
                          color: "#4B5768",
                        }}
                      >
                        {order.created_by_name}
                      </div>
                    </Box>

                    {/* Media (IMAGE/VIDEO RIGHT) */}
                    {(() => {
                      let mediaFiles;
                      try {
                        mediaFiles =
                          typeof order.order_images === "string"
                            ? JSON.parse(order.order_images)
                            : order.order_images || [];
                      } catch (error) {
                        console.error("Error parsing media:", error);
                        mediaFiles = [];
                      }

                      const firstMedia = mediaFiles?.[0];
                      if (!firstMedia) return null;

                      const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(
                        firstMedia
                      );
                      const isVideo = /\.(mp4|webm|ogg)$/i.test(firstMedia);
                      const isPdf = /\.(PDF|pdf)$/i.test(firstMedia);

                      const mediaBoxStyle = {
                        width: 80,
                        height: 80,
                        objectFit: "cover",
                        borderRadius: 4,
                      };

                      return (
                        <Box>
                          {isImage ? (
                            <a
                              href={firstMedia}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={firstMedia}
                                alt="Order"
                                style={mediaBoxStyle}
                              />
                            </a>
                          ) : isVideo ? (
                            <Box
                              onClick={() => window.open(firstMedia, "_blank")}
                              sx={{ cursor: "pointer" }}
                            >
                              <video
                                width="80"
                                height="80"
                                style={mediaBoxStyle}
                                muted
                                loop
                                playsInline
                              >
                                <source src={firstMedia} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            </Box>
                          ) : isPdf ? (
                            <Box
                              onClick={() => window.open(firstMedia, "_blank")}
                              sx={{ cursor: "pointer" }}
                            >
                              <iframe
                                src={firstMedia}
                                title="PDF Preview"
                                width="80"
                                height="80"
                                style={{
                                  ...mediaBoxStyle,
                                  border: "1px solid #ccc",
                                }}
                              />
                            </Box>
                          ) : null}
                        </Box>
                      );
                    })()}
                  </Box>
                </TableCell>
                {/* <TableCell>{order.itemtype_name}</TableCell> */}
                {/* <TableCell>{order.store_name}</TableCell>


                {role === "MFR" ? (
                  <TableCell>
                    {customers.find((customer) => customer.id === Number(order.store_id))?.name || ""}
                  </TableCell>
                ) : (
                  <TableCell>
                    {customers.find((store) => store.id === Number(order.store_id))?.name || ""}
                  </TableCell>
                )} */}

                {/* Order Date */}
                <TableCell>
                  {order.orderdate
                    ? new Date(order.orderdate).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                    })
                    : ""}
                </TableCell>

                {/* Order Type */}
                <TableCell>{order.order_type}</TableCell>

                {/* Delivery Date */}
                <TableCell>
                  {order.deliverydate
                    ? new Date(order.deliverydate).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                    })
                    : ""}
                </TableCell>

                {/* Store Name */}
                <TableCell>{order.store_name}</TableCell>

                {/* Customer Name */}
                <TableCell>{order.customer_name}</TableCell>

                {/* Karigara Name */}
                <TableCell>{order.karigar_name}</TableCell>

                {/* Karigara Delivery Date */}
                <TableCell>
                  {order.karigar_delivery_date
                    ? new Date(order.karigar_delivery_date).toLocaleDateString(
                      "en-GB",
                      {
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit",
                      }
                    )
                    : ""}
                </TableCell>

                {/* Order Description */}
                <TableCell>{order.description}</TableCell>

                {/* Order Status */}
                <TableCell>
                  {(() => {
                    const excludedStatuses = [5, 6, 7, 9, 11];
                    const today = new Date();
                    const deliveryDate = new Date(order.deliverydate);

                    if (order.work_status_id === 5) {
                      return (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          Completed
                        </span>
                      );
                    }

                    if (
                      !excludedStatuses.includes(order.work_status_id) &&
                      order.deliverydate && // customer self orders start without one
                      deliveryDate < today
                    ) {
                      const timeDiff = today - deliveryDate;
                      const daysOverdue = Math.ceil(
                        timeDiff / (1000 * 60 * 60 * 24)
                      );
                      return (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          Overdue by {daysOverdue} day
                          {daysOverdue > 1 ? "s" : ""}
                        </span>
                      );
                    }
                    if (order.work_status.toLowerCase() === "delivered") {
                      return (
                        <>
                          <div>
                            <div style={{ fontWeight: "bold" }}>
                              {order.work_status}
                            </div>
                            <div style={{ fontSize: "0.8rem", color: "#555" }}>
                              {order.delivereddate}
                            </div>
                          </div>
                        </>
                      );
                    }
                    return order.work_status;
                  })()}
                </TableCell>

                {/* Order Quantity */}
                <TableCell>{order.pcs}</TableCell>

                {/* Order Purity */}
                <TableCell>
                  {(purities.find((purity) => order.purity_id === purity.id)?.name
                    ? purities.find((purity) => order.purity_id === purity.id)?.name
                    : "--")}
                </TableCell>

                {/* Order Gross Weight */}
                <TableCell>
                  {role === "SUPERADMIN" && order.work_status_id === 5
                    ? order.total_gross_wt
                    : order.weight}
                </TableCell>

                {/* Order Net Weight */}
                <TableCell>
                  {role === "SUPERADMIN" && order.work_status_id === 5
                    ? order.total_net_wt
                    : order.netwt}
                </TableCell>

                {/* <TableCell>{order.work_status_id}</TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={3}
        mb={12}
        sx={{ zIndex: 9999 }}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={handleDeliveryToWorkshop}
          sx={{ mb: 0 }}
        >
          Delivery to Workshop
        </Button>

        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          // color="primary"
          // border="1px solid #D0D5DD"
          sx={{
            ml: "auto", // Push to the right side
            display: "flex",
            justifyContent: "flex-end",
            "& .MuiPaginationItem-root": {
              borderRadius: "4px", // Square border radius
              margin: "0 4px", // Space between pagination buttons
              padding: "6px 12px", // Adjust padding to look like square
            },
            "& .Mui-selected": {
              border: "2px solid #0D7377", // Add a border to the active (selected) item
              backgroundColor: "transparent", // Optional: to ensure background is not overridden
            },
            // backgroundColor: "yellow", // Optional, if you want a background color
            padding: "10px", // Padding around pagination
            border: "1px solid #D0D5DD", // Apply border color
          }}
        />
      </Box>

      <Modal open={isRemoveMediaOpen} onClose={handleCloseModals}>
        <Box
          sx={{
            p: 2,
            bgcolor: "white",
            borderRadius: "8px",
            width: 400,
            mx: "auto",
            my: 10,
          }}
        >
          <Typography variant="h6">Remove Media</Typography>
          {selectedOrder?.order_images &&
            JSON.parse(selectedOrder.order_images).map((media, index) => (
              <div
                key={index}
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                {media.match(/\.(jpeg|jpg|png|gif|webp)$/) ? (
                  <img src={media} alt={`Media ${index}`} width={100} />
                ) : (
                  <video src={media} width={100} controls />
                )}
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => handleRemoveMedia(media)}
                >
                  Remove
                </Button>
              </div>
            ))}
          <Button onClick={handleCloseModals}>Close</Button>
        </Box>
      </Modal>

      {/* Add Media Modal */}
      <Modal open={isAddMediaOpen} onClose={handleCloseModals}>
        <Box
          sx={{
            width: { xs: "90%", sm: 420 },
            mx: "auto",
            my: 8,
            p: 4,
            bgcolor: "#fff",
            borderRadius: 3,
            boxShadow: 4,
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          {/* Heading */}
          <Typography variant="h6" fontWeight={600} textAlign="center">
            Upload Media
          </Typography>

          {/* File input + label row */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Button
              variant="outlined"
              component="label"
              sx={{ textTransform: "none", fontWeight: 500 }}
            >
              Select Files
              <input
                type="file"
                hidden
                multiple
                onChange={(e) => setSelectedFiles([...e.target.files])}
              />
            </Button>

            <Typography
              variant="body2"
              sx={{
                color:
                  selectedFiles.length === 0
                    ? "text.secondary"
                    : "text.primary",
                fontStyle: selectedFiles.length === 0 ? "italic" : "normal",
                maxWidth: "calc(100% - 140px)",
                wordBreak: "break-word",
                fontSize: "0.9rem",
              }}
            >
              {selectedFiles.length > 0
                ? selectedFiles.map((f) => f.name).join(", ")
                : "No file chosen"}
            </Typography>
          </Box>

          {/* Upload & Close buttons */}
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleUploadMedia(selectedFiles)}
              disabled={selectedFiles.length === 0}
              fullWidth
              sx={{ textTransform: "none", fontWeight: 500 }}
            >
              Upload
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleCloseModals}
              fullWidth
              sx={{ textTransform: "none", fontWeight: 500 }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Edit Order Dialogue Box */}
      {editedOrder && (
        <Dialog
          open={isModalOpen}
          onClose={handleModalClose}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Edit Order</DialogTitle>
          <DialogContent sx={{ marginY: 2 }}>
            <Grid container spacing={2}>
              {/* Order ID */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Order ID"
                  name="Order ID"
                  value={editedOrder.storeorderno}
                  onChange={handleEditChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  sx={{
                    mt: 1,
                    "& .MuiInputLabel-root": {
                      top: 2, // adjust if label overlaps
                    },
                  }}
                />
              </Grid>

              {/* Order Date */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Order Date"
                  type="date"
                  name="orderdate"
                  value={editedOrder.orderdate}
                  onChange={handleEditChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  sx={{
                    mt: 1,
                    "& .MuiInputLabel-root": {
                      top: 2, // adjust if label overlaps
                    },
                  }}
                />
              </Grid>

              {/* Delivery Date */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Delivery Date"
                  type="date"
                  name="deliverydate"
                  value={editedOrder.deliverydate}
                  onChange={handleEditChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                />
              </Grid>

              {/* Karigar Delivery Date */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Karigar Delivery Date"
                  type="date"
                  name="karigar_delivery_date"
                  value={editedOrder.karigar_delivery_date}
                  onChange={handleEditChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                />
              </Grid>

              {/* Customer Order Number */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Customer Order Number"
                  name="customer_order_number"
                  value={editedOrder.customer_order_number}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              {/* Customer Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Customer Name"
                  name="customer_name"
                  value={editedOrder.customer_name}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              {/* Item Type */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Item Type"
                  name="itemtype_id"
                  value={editedOrder.itemtype_id}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                >
                  {itemtypes.map((status) => (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Design */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Design"
                  name="design_id"
                  value={editedOrder.design_id}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                >
                  {designs.map((status) => (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Gross Weight */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Gross Weight"
                  name="weight"
                  value={editedOrder.weight}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              {/* Net Weight */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Net Weight"
                  name="netwt"
                  value={editedOrder.netwt}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              {/* Purity */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Purity"
                  name="purity_id"
                  value={editedOrder.purity_id}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                >
                  {purities.map((purity) => (
                    <MenuItem key={purity.id} value={purity.id}>
                      {purity.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* PCs */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="PCS"
                  name="pcs"
                  value={editedOrder.pcs}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              {/* Descritpion */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Descritpion"
                  name="description"
                  value={editedOrder.description}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                  multiline
                  rows={4}
                />
              </Grid>

              {/* Sample Weight */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Sample Weight"
                  name="sample_weight"
                  value={editedOrder.sample_weight}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              {/* Semi Finished Weight */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Semi Finished Weight"
                  name="semifinishedwt"
                  value={editedOrder.semifinishedwt}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              {/* Karigar */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Karigar"
                  name="karigar_id"
                  value={editedOrder.karigar_id}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                >
                  {karigars.map((status) => (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Size/Length */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Size/Length"
                  name="size_len"
                  value={editedOrder.size_len}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              {/* Work Status */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Work Status"
                  name="work_status_id"
                  value={editedOrder.work_status_id}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                >
                  {allstatus
                    .filter(
                      (status) => role === "SUPERADMIN" || status.id !== 5
                    )
                    .map((status) => (
                      <MenuItem key={status.id} value={status.id}>
                        {status.name}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>

              {/* Store Name */}
              <Grid item xs={12} sm={6}>
                {role === "SUPERADMIN" ? (
                  <Autocomplete
                    options={customers}
                    getOptionLabel={(option) => option.name} // Display customer name
                    onChange={(event, newValue) => {
                      handleEditChange({
                        target: {
                          name: "store_id",
                          value: newValue ? newValue.id : "",
                        },
                      });
                    }}
                    value={
                      customers.find((c) => c.id === editedOrder.store_id) ||
                      null
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Store Name"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                ) : (
                  <Autocomplete
                    options={mfrstore}
                    getOptionLabel={(option) => option.name} // Display store name
                    onChange={(event, newValue) => {
                      handleEditChange({
                        target: {
                          name: "store_id",
                          value: newValue ? newValue.id : "",
                        },
                      });
                    }}
                    value={
                      mfrstore.find((c) => c.id === editedOrder.store_id) ||
                      null
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Store Name"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                )}
              </Grid>

              {/* Screw Type */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Screw Type"
                  name="screw_type_id"
                  value={editedOrder.screw_type_id}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                >
                  {screwTypes.map((status) => (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Color */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Color"
                  name="finishtype_id"
                  value={editedOrder.finishtype_id}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                >
                  {finishtypes.map((status) => (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Weight Range */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Weight Range"
                  name="wt_range"
                  value={editedOrder.wt_range}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                  multiline
                  rows={4}
                />
              </Grid>

              {/* Order Type */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Order Type"
                  name="order_type"
                  value={editedOrder.order_type}
                  onChange={handleEditChange}
                  fullWidth
                  variant="outlined"
                >
                  <MenuItem value="Stock">Stock</MenuItem>
                  <MenuItem value="Customer">Customer</MenuItem>
                </TextField>
              </Grid>

              {/* Order Images */}
              <Grid item xs={12}>
                {editedOrder.order_images &&
                  (() => {
                    // Parse JSON string of media URLs
                    let mediaFiles = [];
                    try {
                      mediaFiles = JSON.parse(editedOrder.order_images); // Parse JSON string into array
                    } catch (e) {
                      console.error("Error parsing media files:", e);
                    }

                    // Check if there are any media files
                    if (mediaFiles.length > 0) {
                      return mediaFiles.map((media, index) => {
                        // Check if the current media is an image
                        if (media.match(/\.(jpeg|jpg|png|gif|webp)$/)) {
                          return (
                            <div key={index} style={{ marginBottom: "1rem" }}>
                              <img
                                src={media}
                                alt={`Order Image ${index}`}
                                style={{
                                  width: "100%",
                                  maxHeight: "300px",
                                  objectFit: "contain",
                                  marginBottom: "1rem",
                                }}
                              />
                            </div>
                          );
                        }

                        // Check if the current media is a video
                        if (media.match(/\.(mp4|webm|ogg)$/)) {
                          return (
                            <div key={index} style={{ marginBottom: "1rem" }}>
                              <video
                                controls
                                style={{
                                  width: "100%",
                                  maxHeight: "300px",
                                  objectFit: "contain",
                                  marginBottom: "1rem",
                                }}
                              >
                                <source src={media} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          );
                        }

                        return null; // Return nothing if it's neither an image nor a video
                      });
                    }

                    return (
                      <Typography color="textSecondary">
                        No image or video uploaded.
                      </Typography>
                    );
                  })()}

                {/* <Button variant="contained" component="label" color="primary">
                  Upload New Media
                  <input
                    type="file"
                    accept="image/*,video/*" // Allow both images and videos
                    hidden
                    onChange={handleImageUpload} // Handle file upload
                  />
                </Button> */}
              </Grid>
            </Grid>
          </DialogContent>

          {/* Buttons */}
          <DialogActions>
            {/* Cancel Button */}
            <Button onClick={handleModalClose} color="secondary">
              Cancel
            </Button>
            {/* Save Button */}
            <Button onClick={handleSaveEditedOrder} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Auto close after 6 seconds
        onClose={() => setOpenSnackbar(false)} // Close the Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        sx={{
          '&.MuiSnackbar-root': {
            bottom: '100px !important', // force override snackbar position
          }
        }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default OrderSearch;
